<template>
  <div id="wrapper">
    <MCHeader />
    <MCQuote />
    <MCAbout />
    <MCTestimonials />
    <MCArchive />
  </div>
</template>

<script>
    import MCTestimonials from "./MCTestimonials";
    import MCAbout from "./MCAbout";
    import MCQuote from "./MCQuote";
    import MCHeader from "./MCHeader";
    import MCArchive from "./MCArchive";

    export default {
        name: "MarinConstantin",
        components: {
            MCArchive,
            MCHeader,
            MCQuote,
            MCAbout,
            MCTestimonials
        },
    }
</script>

<style scoped>
</style>
